import {
  REPORT_FILTER_DIMENSIONS,
  type ReportWidgetFilters
} from "../types/canvas.types.ts"

const createEmptyReportWidgetFilters = (): ReportWidgetFilters =>
  Object.fromEntries(
    REPORT_FILTER_DIMENSIONS.map((dim) => [dim, []])
  ) as ReportWidgetFilters

// Comma-separated id strings per dimension, keyed by dimension name, empty dimensions
// omitted. Report-wide filters feed the resolve query params (reportResolveParams);
// per-widget filters feed config.filter (reportWidgetAdapter).
const buildWidgetFilterPayload = (
  filters: ReportWidgetFilters | undefined
): Record<string, string> => {
  const payload: Record<string, string> = {}
  if (!filters) return payload
  for (const dim of REPORT_FILTER_DIMENSIONS) {
    const values = filters[dim]
    if (values && values.length > 0) payload[dim] = values.join(",")
  }
  return payload
}

const countActiveReportFilters = (
  filters: ReportWidgetFilters | undefined
): number =>
  filters
    ? REPORT_FILTER_DIMENSIONS.filter((dim) => (filters[dim]?.length ?? 0) > 0)
        .length
    : 0

export {
  createEmptyReportWidgetFilters,
  buildWidgetFilterPayload,
  countActiveReportFilters
}
